module.exports = __webpack_public_path__ + "static/media/delete.b9790365.svg";